export const environment = {
    version: '8aed20472cad6a6cf38e9e770710a9d15d3feb53',
    production: false,
    kinde_client_id: "6157fef382a14ee7bd85f645e65652b7",
    kinde_url: "https://lobster-test.eu.kinde.com",
    api_url: "https://api.lobster.technology",
    google_maps_api_key: "AIzaSyAmHBdp5FH3Vbf7Z29iS7glr_lBnq01woY"
};
